// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import {
  NewsInfoResponseDTO,
  NewsListInfoResponseDTO,
  NewsPreviewResponseDTO,
  NewsPublishWorkflowRequestDTO,
  NewsSearchRequestDTO,
  NewsWorkflowRequestDTO,
  NewsWriteRequestDTO
} from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import {
  restArchiveHandler,
  restCreationHandler,
  restDeletionHandler,
  restDestroyHandler,
  restDetailsHandler,
  restDuplicationHandler,
  restListHandlerPagination,
  restUpdateHandler,
  restWorkflowHandler,
  restWorkflowPublishHandler
} from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const newsUrl = baseUrl + "/news/";
const archiveUrl = "/archive";
const unarchiveUrl = "/unarchive";

export const requestGetNewsList = createEffect({
  handler: restListHandlerPagination<
    NewsSearchRequestDTO,
    NewsListInfoResponseDTO
  >(newsUrl + "search")
});
export const requestGetNews = createEffect({
  handler: restDetailsHandler<NewsInfoResponseDTO>(newsUrl)
});
export const requestGetNewsPreview = createEffect({
  handler: restDetailsHandler<NewsPreviewResponseDTO>(newsUrl + "preview/")
});
export const requestCreateNews = createEffect({
  handler: restCreationHandler<NewsWriteRequestDTO, NewsInfoResponseDTO>(
    newsUrl
  )
});
export const requestUpdateNews = createEffect({
  handler: restUpdateHandler<NewsWriteRequestDTO, NewsInfoResponseDTO>(newsUrl)
});
export const requestDuplicateNews = createEffect({
  handler: restDuplicationHandler<NewsInfoResponseDTO>(newsUrl)
});
export const requestDeleteNews = createEffect({
  handler: restDeletionHandler<NewsInfoResponseDTO>(newsUrl)
});
export const requestArchiveNews = createEffect({
  handler: restArchiveHandler<NewsInfoResponseDTO>(newsUrl, archiveUrl)
});
export const requestUnarchiveNews = createEffect({
  handler: restArchiveHandler<NewsInfoResponseDTO>(newsUrl, unarchiveUrl)
});
export const requestDestroyNews = createEffect({
  handler: restDestroyHandler<NewsInfoResponseDTO>(newsUrl)
});
export const requestWorkflowNews = createEffect({
  handler: restWorkflowHandler<NewsWorkflowRequestDTO, NewsInfoResponseDTO>(
    newsUrl
  )
});
export const requestWorkflowPublishNews = createEffect({
  handler: restWorkflowPublishHandler<
    NewsPublishWorkflowRequestDTO,
    NewsInfoResponseDTO
  >(newsUrl)
});
export const requestWorkflowUnpublishNews = createEffect({
  handler: restWorkflowPublishHandler<
    NewsPublishWorkflowRequestDTO,
    NewsInfoResponseDTO
  >(newsUrl)
});
